﻿function onChangeFilters(event) {
    const costValue = $(this).val();
    if (costValue === "4") {
        $('.threeyear').hide();
        $('.fouryear').show();
    }
    else {
        $('.threeyear').show();
        $('.fouryear').hide();
    }
}
export function setupCarReview() {
    //dropdown changes
    $(document).on('change', '[data-running-costs-dropdown]', onChangeFilters);

}
